export default __webpack_public_path__ + "static/kurgo-site-mountains_1920wide-bdfe3af9b5e77a9df2b456e3b7c2247e.jpg";